import React from 'react'
import {Helmet} from 'react-helmet-async'

import {usePageTitle} from '../../hooks/usePageTitle'

export function HelmetTitle({title}: {title?: string}) {
  const pageTitle = usePageTitle(title)
  return <Helmet title={pageTitle} />
}
